// src/constants/customerSidebarMenusData.js
const customerSidebarMenusData = [
  { id: 1, url: 'dashboard', text: 'Dashboard', icon: 'fa-solid fa-tachometer-alt' },

  // NEW PAGES
  { id: 2, url: 'credit',        text: 'My Credit',  icon: 'fa-solid fa-coins'      },
  //{ id: 3, url: 'unpaid-credit', text: 'Unpaid Due', icon: 'fa-solid fa-money-bill' },
  { id: 4, url: 'orders',        text: 'My Orders',  icon: 'fa-solid fa-receipt'    },

  // already-existing “Go Order” entry
//  { id: 5, url: 'order', text: 'Go Order', icon: 'fa-solid fa-utensils' },
];

export default customerSidebarMenusData;
